import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUpRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m4 12 8-8M5.5 4H12v6.5"
	})
});
export default SvgArrowUpRight;
